import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import store from '@/stores/front';

Vue.use(VueRouter);

const FoodPage = () => import(/* webpackChunkName: "js/chunks/food" */'./pages/Food.vue');
const AccountPage = () => import(/* webpackChunkName: "js/chunks/user" */'./pages/Account.vue');
const OrdersPage = () => import(/* webpackChunkName: "js/chunks/user" */'./pages/Orders.vue');
const ProductCustomizer = () => import(/* webpackChunkName: "js/chunks/customizer" */'../components/front/product-customizer/ProductCustomizer.vue');
const ClosedPage = () => import(/* webpackChunkName: "js/chunks/food" */'./pages/ClosedPage.vue');
const ContactPage = () => import(/* webpackChunkName: "js/chunks/food" */'./pages/ContactPage.vue');
const PageNotFound = () => import(/* webpackChunkName: "js/chunks/food" */'./pages/PageNotFound.vue');
const Policy = () => import(/* webpackChunkName: "js/chunks/food" */'./pages/Policy.vue');
const Offline = () => import(/* webpackChunkName: "js/chunks/food" */'./pages/Offline.vue');
const PrivacyTool = () => import(/* webpackChunkName: "js/chunks/food" */'./pages/PrivacyTool.vue');

import { getModule } from 'vuex-module-decorators';
import { isStoreOpen } from '@/utils/store-schedule';
import AppModule from '@/stores/modules/app';

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/closed',
            name: 'closed',
            component: ClosedPage
        },
        {
            path: '/offline',
            name: 'offline',
            component: Offline
        },
        {
            path: '/',
            name: 'food',
            component: FoodPage
        },
        {
            path: '/account',
            name: 'account',
            component: AccountPage
        },
        {
            path: '/contact-us',
            name: 'contact',
            component: ContactPage
        },
        {
            path: '/orders',
            name: 'orders',
            component: OrdersPage
        },
        {
            path: '/privacy-policy',
            name:'privacy',
            component: Policy,
            props: { type: 'privacy-policy' },
        },
        {
            path: '/cookie-policy',
            name:'cookie',
            component: Policy,
            props: { type: 'cookie-policy' }
        },
        {
            path: '/terms-of-use',
            name: 'terms',
            component: Policy,
        },
        {
            path: '/privacy-tool',
            name: 'privacy-tool',
            component: PrivacyTool
        },
        {
            path: '/:pageSlug/',
            name:'product-page',
            component: FoodPage,
            props: true,
            children: [
                {
                    path: ':productSlug/:productId',
                    props: route => ({
                        productSlug: route.params.productSlug,
                        productId: route.params.id,
                    }),
                    name: 'edit-product',
                    component: ProductCustomizer
                },
            ]
        },
        {
            path: '/404',
            name: 'page-not-found',
            component: PageNotFound
        }

    ]
});

function setPageMetas(to: Route) {
    if (window.getPageMetas !== undefined) {
        const pageMetas = (<any>window).getPageMetas(to.name);
        if (pageMetas !== undefined && (<any>window).websiteName) {
            document.title = pageMetas.title + ' - ' + (<any>window).websiteName;
            (<any>document.getElementsByTagName('meta'))['description'].content = (pageMetas.meta_description) ? pageMetas.meta_description : (<any>window).storeDescription;
        }
    }
}

function checkIfOnline(to: Route, next: Function) {
    const appModule = getModule(AppModule, store);
    if (!appModule.isOnline && to.name !== 'offline') {
        return next({name: 'offline'});
    }
    next();
}

async function checkIfClosed(to: Route, next: Function) {
    if (['food', 'product-type', 'product-page', 'closed'].includes(to.name as string)) {
        const isOpen = await isStoreOpen();
        return next({ name: isOpen ? (to.name === 'closed' ? 'food' : {}) : 'closed' });
    }
    next();
}

async function beforeEachRoute(to: Route, from: Route, next: Function) {
    checkIfOnline(to, next);
    await checkIfClosed(to, next);
    next();
}

export function handleRoutes() {
    router.beforeEach(async (to: Route, from: Route, next: Function) => {
        beforeEachRoute(to, from, next);
    });
    router.afterEach((to: Route, from: Route) => {
        setPageMetas(to);
    });
    initialRouteCheck(router.currentRoute);
}

async function initialRouteCheck(route: Route) {
    if (['food', 'product-type', 'product-page', 'closed'].includes(route.name as string)) {
        const isOpen = await isStoreOpen();
        if (isOpen) {
            if (route.name === 'closed') {
                router.push({ name: 'food' });
            }
        } else {
            if (route.name !== 'closed') {
                router.push({ name: 'closed' });
            }
        }
    }
}
export default router;
